<template>
  <div>
    <McButton
      variant="primary"
      text="Pembaruan Kontrak"
      icon="icon-outline_checkmark"
      @click="triggerModal"
    />

    <b-modal
      static
      title="Pembaruan Kontrak?"
      ref="mc-modal-confirm"
      size="md"
      centered
      scrollable
      hide-header-close
    >
      <div>
        <p>Apakah anda yakin ingin membuat kontrak baru dengan data yang sama?</p>
        <p>Pembaruan ini akan <strong>membentuk nomor kontrak baru</strong></p>
      </div>

      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0">
          <McButton
            :disabled="isLoading"
            @click="cancel()"
            variant="secondary"
            class="me-2"
            text="Tidak"
          />
          <McButton
            :disabled="isLoading"
            @click="handleContractRenew"
            variant="primary"
            text="Ya"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

import * as Renewal from '@/services/rest-api/lib/contract/renewal'

export default {
  components: {
    McButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    prefixUrl() {
      return {
        vendorId: this.$route.params.vendorId,
        contractId: this.$route.params.contractId,
        versionId: this.$route.params.versionId,
      }
    },
  },
  methods: {
    async handleContractRenew() {
      this.isLoading = true
      const res = await Renewal.renew(this.prefixUrl)

      if (!res || res.errors) {
        this.$mcToast.error('Terjadi kesalahan')
        this.isLoading = false
        return
      }

      const { vendor_id, contract_id, version_id } = res.data

      this.$mcToast.success('Kontrak berhasil diperbarui')
      this.$refs['mc-modal-confirm'].hide()

      this.$router.push({
        name: 'Master Vendor Contract Detail',
        params: {
          vendorId: vendor_id,
          contractId: contract_id,
          versionId: version_id,
        },
        query: { renewal: true },
      })

      this.isLoading = false
    },

    triggerModal() {
      this.$refs['mc-modal-confirm'].show()
    },
  },
}
</script>

<style lang="scss" scoped></style>
